<div *ngIf="showNotification" class="install-notification">
  <h3>Добавьте этот сайт на главный экран</h3>
  <p *ngIf="isAndroid">
    Откройте меню браузера (⋮) и выберите <strong>"Добавить на главный экран"</strong>.
  </p>
  <p *ngIf="isIOS">
    Нажмите кнопку <strong>"Поделиться" (⬆️)</strong> и выберите <strong>"На экран Домой"</strong>.
  </p>
  <button (click)="closeNotification()">Закрыть</button>
</div>
